module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-list",
    class: {
      compact: _vm.compact && _vm.level === 1, submenu: _vm.level > 1
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('list-item', {
      key: index,
      staticClass: "nav-item",
      attrs: {
        "text": item.text,
        "items": item.children,
        "to": item.to,
        "external": item.external,
        "target": item.target,
        "callback": item.callback,
        "level": _vm.level,
        "wide": _vm.level === 1 && _vm.small,
        "max-level": _vm.maxLevel
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab93ab2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/private/List.vue
// module id = 7ff66a878e865788208e
// module chunks = 0